import { DatePicker } from '@pay-com/components'
import {
  Controller,
  FieldPath,
  FieldValues,
  useFormContext
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { getErrorMessage } from 'utils/get-error-message'

interface ControlledDatePickerProps<T extends FieldValues> {
  name: FieldPath<T>
  label?: string
  placeholder?: string
  disabled?: boolean
  isLoading?: boolean
  className?: string
}

export const ControlledDatePicker = <T extends FieldValues>({
  name,
  label,
  placeholder,
  disabled,
  isLoading,
  className
}: ControlledDatePickerProps<T>) => {
  const { control } = useFormContext<T>()
  const { t } = useTranslation('errors')

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { error } = fieldState

        return (
          <DatePicker
            value={
              field.value && Number(field.value)
                ? new Date(Number(field.value))
                : null
            }
            onChange={(date: Date | null) => {
              field.onChange(date ? Number(date) : null)
              field.onBlur()
            }}
            label={label}
            placeholder={placeholder}
            disabled={disabled || isLoading}
            errorMessage={getErrorMessage(t, error?.message)}
            className={className}
            UTCFormat
          />
        )
      }}
    />
  )
}
